export function initializeMonitoring() {
    if (window.newrelic) {
      const userAgent = navigator.userAgent;
      const platform = navigator.platform;
      const browserInfo = {
        userAgent,
        platform,
        browserName: getBrowserName(userAgent),
        osName: getOSName(userAgent)
      };
  
      window.newrelic.addPageAction('userInfo', browserInfo);
    }
  }
  
  function getBrowserName(userAgent) {
    if (userAgent.includes('Firefox')) return 'Firefox';
    if (userAgent.includes('SamsungBrowser')) return 'SamsungBrowser';
    if (userAgent.includes('OPR') || userAgent.includes('Opera')) return 'Opera';
    if (userAgent.includes('Trident') || userAgent.includes('MSIE')) return 'Internet Explorer';
    if (userAgent.includes('Edge')) return 'Edge';
    if (userAgent.includes('Chrome')) return 'Chrome';
    if (userAgent.includes('Safari')) return 'Safari';
    return 'Unknown';
  }
  
  function getOSName(userAgent) {
    if (userAgent.includes('Win')) return 'Windows';
    if (userAgent.includes('Mac')) return 'MacOS';
    if (userAgent.includes('X11')) return 'Unix';
    if (userAgent.includes('Linux')) return 'Linux';
    return 'Unknown';
  }
  